import { createContext, useContext } from 'react';

import type { CurrentOperator } from '@/api/auth';

export interface AuthContextValue {
  operator: CurrentOperator | null;
  isLoading: boolean;
  signOut: () => Promise<void>;
}

export const AuthContext = createContext<AuthContextValue | null>(null);

export function useAuth(): AuthContextValue {
  const ctx = useContext(AuthContext);
  if (ctx === null) throw new Error('useAuth called outside AuthProvider');
  return ctx;
}
